import React from "react";
import "./Services.scss";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      name: "Medicines",
      description: [
        "Dewormers",
        "Flea",
        "Tick",
        "Antibiotics",
        "Pain Relievers",
      ],
      imgSrc: "/medicine.jpeg",
      route: "/medicines",
    },
    {
      name: "Vaccination",
      description: [
        "Rabies",
        "Distemper",
        "Parvovirus",
        "Hepatitis",
        "Leptospirosis",
      ],
      imgSrc: "/vaccination.jpeg",
      route: "/vaccination",
    },
    {
      name: "Grooming",
      description: [
        "Bathing",
        "Haircut",
        "Nail Trimming",
        "Ear Cleaning",
        "Teeth Brushing",
      ],
      imgSrc: "/groomimg.jpg",
      route: "/grooming",
    },
  ];

  return (
    <>
      <div className="services-container">
        <h3>Our Services</h3>
        <h2>Where Passion Meets Purpose</h2>
        <div className="servicepage">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-image-container">
                <img src={service.imgSrc} alt={service.name} />
              </div>

              <div className="service-content">
                <h2>{service.name}</h2>
                <ul>
                  {service.description.map((desc, index) => (
                    <li key={index}>{desc}</li>
                  ))}
                </ul>
                <button
                  className="explore"
                  onClick={() => navigate(service.route)}
                >
                  Explore Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Services;
